<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/ordermanagement/topAfter')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <el-descriptions border>
      <el-descriptions-item label="初审时间">{{
        info.applyTime ? info.applyTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核状态">{{
        info.state == 1
          ? "初审中"
          : info.state == 6
          ? "已撤销"
          : info.state == 7 || info.state == 2
          ? "初审通过"
          : (info.rechargeRefundType == 1 && info.applyTimeTwo) ||
            (info.rechargeRefundType == 2 && info.examineTime)
          ? "初审通过"
          : "初审驳回"
      }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{
        info.applyName ? info.applyName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="备注">{{
        info.applyMsg ? info.applyMsg : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="图片">
        <div v-if="!info.applyImg">- -</div>
        <div v-if="info.applyImg">
          <el-image
            class="mgr-15"
            v-for="(v, i) in info.applyImg.split(',')"
            :key="i"
            style="width: 100px; height: 100px"
            :src="v"
            :preview-src-list="info.applyImg.split(',')"
          >
          </el-image></div
      ></el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      border
      class="mgt-20"
      v-if="
        info.rechargeRefundType == 1 && (info.state == 7 || info.applyTimeTwo)
      "
    >
      <el-descriptions-item label="复审时间">{{
        info.applyTimeTwo ? info.applyTimeTwo : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核状态">{{
        info.state == 7
          ? "复审中"
          : info.state == 6
          ? "已撤销"
          : info.state == 8
          ? "复审通过"
          : (info.rechargeRefundType == 1 && info.examineTime) ||
            (info.rechargeRefundType == 2 && info.state !== 5)
          ? "复审通过"
          : "复审驳回"
      }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{
        info.applyNameTwo ? info.applyNameTwo : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="备注">{{
        info.applyMsgTwo ? info.applyMsgTwo : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="图片">
        <div v-if="!info.applyImgTwo">- -</div>
        <div v-if="info.applyImgTwo">
          <el-image
            class="mgr-15"
            v-for="(v, i) in info.applyImgTwo.split(',')"
            :key="i"
            style="width: 100px; height: 100px"
            :src="v"
            :preview-src-list="info.applyImgTwo.split(',')"
          >
          </el-image></div
      ></el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      border
      class="mgt-20"
      v-if="
        info.rechargeRefundType == 2
          ? info.state == 2 || info.examineTime
          : info.state == 8 || info.examineTime
      "
    >
      <el-descriptions-item
        :label="info.rechargeRefundType == 1 ? '终审时间' : '复审时间'"
        >{{ info.examineTime ? info.examineTime : "- -" }}</el-descriptions-item
      >
      <el-descriptions-item
        label="审核状态"
        v-if="info.rechargeRefundType == 2"
        >{{
          info.state == 2
            ? "复审中"
            : info.state == 6
            ? "已撤销"
            : info.state == 5 && info.examineTime
            ? "复审驳回"
            : "复审通过"
        }}</el-descriptions-item
      >
      <el-descriptions-item
        label="审核状态"
        v-if="info.rechargeRefundType == 1"
        >{{
          info.state == 8
            ? "终审中"
            : info.state == 6
            ? "已撤销"
            : info.state == 5 && info.examineTime
            ? "终审驳回"
            : "终审通过"
        }}</el-descriptions-item
      >
      <el-descriptions-item label="操作人">{{
        info.examineName ? info.examineName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="备注">{{
        info.examineMsg ? info.examineMsg : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="图片">
        <div v-if="!info.examineImg">- -</div>
        <div v-if="info.examineImg">
          <el-image
            class="mgr-15"
            v-for="(v, i) in info.examineImg.split(',')"
            :key="i"
            style="width: 100px; height: 100px"
            :src="v"
            :preview-src-list="info.examineImg.split(',')"
          >
          </el-image></div
      ></el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      border
      class="mgt-20"
      v-if="info.state == 3 || info.state == 4"
    >
      <el-descriptions-item label="退款状态">{{
        info.state == 3 ? "待退款" : info.state == 4 ? "已退款" : "- -"
      }}</el-descriptions-item>

      <el-descriptions-item label="退款金额(元)">{{
        info.refundMoney ? info.refundMoney : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="收款人">{{
        info.refundPeople ? info.refundPeople : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="退款方式">{{
        info.refundType ? info.refundType : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="收款账号">{{
        info.refundAccount ? info.refundAccount : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="退款时间">{{
        info.paymentTime ? info.paymentTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="备注">{{
        info.paymentMsg ? info.paymentMsg : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="打款凭证">
        <div v-if="!info.paymentBill">- -</div>
        <div v-if="info.paymentBill">
          <el-image
            class="mgr-15"
            v-for="(v, i) in info.paymentBill.split(',')"
            :key="i"
            style="width: 100px; height: 100px"
            :src="v"
            :preview-src-list="info.paymentBill.split(',')"
          >
          </el-image></div
      ></el-descriptions-item>
      <el-descriptions-item
        label="审核凭证"
        v-if="info.rechargeRefundType == 2"
      >
        <el-button type="primary" @click="lookPz">查看</el-button>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      info: null,
    };
  },
  created() {
    this.info = this.$route.query.data;
  },
  methods: {
    lookPz() {
      this.$router.push({
        path: "/ordermanagement/topAfter/afterDetailVoucher",
        query: {
          data: this.info,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
